import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useTransition } from 'react';
export function useDebouncedTransitionValue(value, t0) {
  const $ = _c(7);
  const delay = t0 === undefined ? 300 : t0;
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [, startTransition] = useTransition();
  let t1;
  if ($[0] !== delay || $[1] !== startTransition || $[2] !== value) {
    t1 = () => {
      const timeout = setTimeout(() => {
        startTransition(() => {
          setDebouncedValue(value);
        });
      }, delay);
      return () => clearTimeout(timeout);
    };
    $[0] = delay;
    $[1] = startTransition;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== delay || $[5] !== value) {
    t2 = [value, delay];
    $[4] = delay;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  return debouncedValue;
}